import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface LanguageState {
  currentLanguage: string;
}

const initialState: LanguageState = {
  currentLanguage: "en", // Default, will be overridden by detection
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    changeLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguage = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { changeLanguage, setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
